import router from '@/router'
import { getToken } from '@/utils/auth'

router.beforeEach(to => {
  const hasToken = Boolean(getToken())
  if (to.meta.public) {
    if (hasToken && (to.name === 'Login' || to.name === 'Register')) return '/requirements'
    return true
  }
  if (hasToken) return true
  return { name: 'Login', query: { redirect: to.fullPath } }
})
